import React, { useEffect } from 'react'
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormSetError,
  UseFormSetValue,
} from 'react-hook-form'
import { cloneDeep } from 'lodash'
import MultipleUpload from 'src/common/upload/MultipleUpload'
import SelectMedia from 'src/components/gallery/SelectMedia'
import { ICreateEventPostValue } from 'src/interfaces/event-posts'

interface IEventRecapContentProps {
  activeTab?: string
  control: Control<ICreateEventPostValue>
  setValue: UseFormSetValue<ICreateEventPostValue>
  clearErrors: UseFormClearErrors<ICreateEventPostValue>
  setError: UseFormSetError<ICreateEventPostValue>
  errors: FieldErrors<ICreateEventPostValue>
  getValues: UseFormGetValues<ICreateEventPostValue>
  contentName?: string
  value?: string
  eventId?: number | string
  eventImages?: any[]
  setEventImages?: React.Dispatch<React.SetStateAction<any[]>>
  onClickSelectThumbnail?: () => void
  isModalLoading?: boolean
}

const EventRecapContent = ({
  activeTab,
  control,
  setValue,
  clearErrors,
  setError,
  errors,
  getValues,
  contentName,
  value,
  eventId,
  eventImages = [],
  setEventImages,
  onClickSelectThumbnail,
  isModalLoading,
}: IEventRecapContentProps) => {
  const onRemoveImage = (index: number) => {
    if (setEventImages) {
      const newImages = cloneDeep(eventImages)
      newImages.splice(index, 1)
      setEventImages(newImages)

      const mediaIds = newImages.map((img) => img.id).filter(Boolean)
      setValue?.('mediaIds', mediaIds)
    }
  }

  useEffect(() => {
    if (setEventImages) {
      const mediaIds = eventImages.map((img) => img.id).filter(Boolean)
      setValue?.('mediaIds', mediaIds)
    }
  }, [eventImages, setValue, setEventImages])

  return (
    <div className="p-5 bg-white">
      <div className="event-recap-content rounded-md border border-slate-200/60 p-5 dark:border-darkmode-400">
        <div className="space-y-6">
          {/* Event Gallery - Multiple Images */}
          {setEventImages && (
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Event Gallery
              </label>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-gray-50">
                <MultipleUpload
                  images={eventImages}
                  setImages={setEventImages}
                  onRemoveImage={onRemoveImage}
                  uploadId={`event-recap-images-${eventId || 'new'}`}
                  maxImages={20}
                />
                {onClickSelectThumbnail && (
                  <SelectMedia
                    onClickSelectMedia={onClickSelectThumbnail}
                    isNotGrid={true}
                    isLoadingMedia={isModalLoading}
                  />
                )}
                <p className="text-gray-500 text-sm mt-2">
                  Upload up to 20 images from the event. Supported formats: JPG,
                  JPEG, PNG, GIF. Max size: 10MB per image.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default EventRecapContent
